import { FlowDurationUnits } from 'flow-schema';
import { z } from 'zod';

import { api } from 'common';

import { SendSmsFormFields } from './FormFields';
import { sendSmsDocumentationMarkdown } from './documentation';
import { CodeMirrorLanguageType } from '../../../../Code/types';
import { type BlockConfigProps } from '../../types';
import { defaultCommunicationWindow } from '../shared/CommunicationWindow';

const SendSmsBlockConfigFormSchema = api.FlowDefinition.SendSmsBlockConfigSchema.extend({
  callerPhoneNumberId: z
    .string({ error: 'Please select a sender phone number.' })
    .uuid('Please select a sender phone number.'),
});

export const sendSmsNodeConfig: BlockConfigProps<api.FlowDefinition.SendSmsBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'SendSms',
  defaultConfig: {
    calleePhoneNumber: '',
    callerPhoneNumberId: null,
    message: 'Hello, this is an automated text from your healthcare provider.',
    runMode: api.FlowDefinition.RunMode.Live,
    timeout: {
      value: 15,
      units: FlowDurationUnits.Minutes,
    },
    communicationWindow: defaultCommunicationWindow,
  },
  configFields: {
    getLanguageFieldValues: (config) => {
      return {
        [CodeMirrorLanguageType.DoubleBraceNodeFields]: [config.calleePhoneNumber, config.message],
      };
    },
    schema: SendSmsBlockConfigFormSchema,
    FormFields: SendSmsFormFields,
  },
  documentationMarkdown: sendSmsDocumentationMarkdown,
};
